// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../types.schema';

export const answerSchema = z.object({
  question: urlSchema,
  value: z.unknown().optional(),
});
